module.exports = __webpack_public_path__ + "media/images/svg/female-768d342c3aca47272257474a3bda797b.svg";